import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsModel } from '../model/icms-model';
import { EdependencyLevel, TLoadDependeciesParams, TLoadParams } from '@df/catalog/model';
import { Injector, runInInjectionContext } from '@angular/core';

export class ICmsConfig<T extends IConfigData = IConfigData> extends ICmsModel<T, number> {
    static override readonly type = 'cmsConfig';
    static readonly cms = true;
    override maxVerbosity = 1;

    @NgInject(ICmsContentService)
    private iCmsContentService!: ICmsContentService;

    @NgInject(Injector)
    private injector!: Injector;

    get meta() {
        return this.iCmsContentService.getConfig(this.data!.url.split('@')[0]);
    }

    override async load(verbosity: number = 1, params?: TLoadParams): Promise<void> {
        if (!params) {
            params = {
                dependencyLevel: EdependencyLevel.details
            };
        }
        if (!params.dependencyLevel) {
            params.dependencyLevel = EdependencyLevel.details;
        }
        return super.load(verbosity, params);
    }

    protected override addDependenciesToLoader(params: TLoadDependeciesParams): void {
        const meta = this.meta;
        const resolvers = meta?.resolvers;
        const loader = params.loader;

        if (resolvers) {
            loader.add(
                (async () => {
                    for (const resolver of Object.values(resolvers)) {
                        await runInInjectionContext(this.injector, () => resolver(this.data! as any));
                    }
                })()
            );
        }
    }

    protected override getName(): string {
        const meta = this.meta;
        if (!meta) {
            return 'Unknown configuration';
        }
        const variant = this.getVariant();
        return variant ? `${meta.name} (${variant})` : meta.name;
    }

    getVariant(): string | undefined {
        return this.data!.url.split('@')[1];
    }

    getBareUrl(): string {
        return this.data!.url.split('@')[0];
    }
}
